import enMessages from '../locales/is_IS.json';

const IsLang = {
  messages: {
    ...enMessages
  },
  locale: 'in', // chrome is missing is-IS
};
export default IsLang;
